import { MutationType } from '@standardnotes/models';
import { Result } from '@standardnotes/domain-core';
export class ChangeAndSaveItem {
    constructor(items, mutator, sync) {
        this.items = items;
        this.mutator = mutator;
        this.sync = sync;
    }
    async execute(itemToLookupUuidFor, mutate, updateTimestamps = true, emitSource, syncOptions) {
        await this.mutator.changeItems([itemToLookupUuidFor], mutate, updateTimestamps ? MutationType.UpdateUserTimestamps : MutationType.NoUpdateUserTimestamps, emitSource);
        await this.sync.sync(syncOptions);
        return Result.ok(this.items.findItem(itemToLookupUuidFor.uuid));
    }
}
